import { useState } from 'react';
import type { Request as OneStopRequest } from './oneStopTypes';
import { FormRowType } from 'framework/form';
import useFormConfigurationMapper from './formConfigurationMapper';

type OneStopConfigurationProps = {
  id: string;
  rowType?: Nullable<FormRowType>;
  getById: (id: string) => Promise<OneStopRequest>;
  prefillData?: Record<string, any>;
};

const useOneStopConfiguration = ({ getById, id, rowType = null, prefillData }: OneStopConfigurationProps) => {
  const [request, setRequest] = useState<Nullable<OneStopRequest> | undefined>(undefined);
  const { getFormConfiguration, getValidationSchema } = useFormConfigurationMapper();

  const getRequestData = async () => {
    if (typeof request !== 'undefined') {
      return request;
    } else {
      const requestData = await getById(id);
      setRequest(requestData);

      return requestData;
    }
  };

  const getFormFieldsConfiguration = async () => {
    const data = await getRequestData();

    return getFormConfiguration(data, rowType, prefillData);
  };

  const getFormValidationSchema = async () => {
    const data = await getRequestData();

    return getValidationSchema(data);
  };

  return {
    getRequestConfiguration: getRequestData,
    getValidationSchema: getFormValidationSchema,
    getFormConfiguration: getFormFieldsConfiguration,
  };
};

export default useOneStopConfiguration;
